import {
  faBus,
  faCar,
  faMotorcycle,
  faPerson,
  faTruck,
} from '@fortawesome/free-solid-svg-icons'
import { Tag } from 'primereact/tag'

export const genderMapping = {
  male: 'Masculino',
  female: 'Feminino',
  unknown: 'Desconhecido',
}

export const booleanMapping = {
  true: 'Sim',
  false: 'Não',
  yes: 'Sim',
  no: 'Não',
  unknown: 'Desconhecido',
}

export const colorMapping = {
  white: 'Branco',
  black: 'Preto',
  red: 'Vermelho',
  blue: 'Azul',
  green: 'Verde',
  yellow: 'Amarelo',
  brown: 'Marrom',
  gray: 'Cinza',
  grey: 'Cinza',
  silver: 'Prata',
  purple: 'Roxo',
  pink: 'Rosa',
  orange: 'Laranja',
  unknown: 'Desconhecido',
}

export const vehicleTypeMap = {
  cars: { icon: faCar, label: 'Carro' },
  car: { icon: faCar, label: 'Carro' },
  bikes: { icon: faMotorcycle, label: 'Moto' },
  bike: { icon: faMotorcycle, label: 'Moto' },
  motorcycle: { icon: faMotorcycle, label: 'Moto' },
  motorcycles: { icon: faMotorcycle, label: 'Moto' },
  trucks: { icon: faTruck, label: 'Caminhão' },
  truck: { icon: faTruck, label: 'Caminhão' },
  buses: { icon: faBus, label: 'Ônibus' },
  bus: { icon: faBus, label: 'Ônibus' },
  people: { icon: faPerson, label: 'Pessoa' },
  person: { icon: faPerson, label: 'Pessoa' },
  vehicle: { icon: faCar, label: 'Veículo' },
  vehicles: { icon: faCar, label: 'Veículos' },
  unknown: { icon: faCar, label: 'Desconhecido' },
} as const

export const formatTime = (timestamp: string) => {
  const date = new Date(timestamp)
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return (
    <Tag
      icon='pi pi-clock'
      severity='info'
      value={`${hours}:${minutes}`}
    ></Tag>
  )
}

export const getDirection = (direction: string) => {
  const directionMapping = {
    reverse: 'Entrando',
    forward: 'Saindo',
    in: 'Entrando',
    out: 'Saindo',
    enter: 'Entrando',
    exit: 'Saindo',
    incoming: 'Entrando',
    outgoing: 'Saindo',
    entrance: 'Entrando',
    leaving: 'Saindo',
    entry: 'Entrando',
    departure: 'Saindo',
  }

  const mappedDirection =
    directionMapping[
      direction.toLowerCase() as keyof typeof directionMapping
    ] || (direction === 'reverse' ? 'Entrando' : 'Saindo')

  return direction === 'reverse' ||
    direction.toLowerCase().includes('in') ||
    direction.toLowerCase() === 'enter' ? (
    <Tag
      icon='pi pi-arrow-down'
      severity='info'
      value={mappedDirection}
    />
  ) : (
    <Tag
      icon='pi pi-arrow-up'
      severity='info'
      value={mappedDirection}
    />
  )
}
